import { selectCurrentUser } from '@user/store/authorization'
import { StoreData } from '@user/store/reducers/typings'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { noAccessSalesTeamSave, noAccessUserSave } from '../constants'
import { selectSalesTeamById } from '../slice'
import { guestRoleName } from '@user/components/Settings/Users/UpdateUser/constants'

export const useGetSalesTeamPermissionMessages = (
  positionsDataStatus: 'pending' | 'success' | 'fail',
  teamId: number | '',
  ownerId: string | null,
) => {
  const salesTeam = useSelector((store) =>
    selectSalesTeamById(store as StoreData, teamId),
  )
  const currentUser = useSelector(selectCurrentUser)
  const isGuestUser = currentUser?.roleName === guestRoleName
  const selectedSalesTeamAccessText = useMemo(() => {
    if (
      positionsDataStatus == 'success' &&
      currentUser &&
      teamId != '' &&
      teamId > 0
    ) {
      return currentUser.isAdmin ||
        isGuestUser ||
        currentUser.salesTeamPositionsData?.salesTeamIds.some(
          (x) => x == teamId,
        )
        ? ''
        : noAccessSalesTeamSave
    } else {
      return ''
    }
  }, [positionsDataStatus, currentUser, teamId, isGuestUser])

  const disableSaveAndView: boolean = useMemo(() => {
    if (
      positionsDataStatus == 'success' &&
      currentUser &&
      teamId != '' &&
      teamId > 0
    ) {
      return !!(
        (!currentUser.isAdmin &&
          !isGuestUser &&
          !currentUser.salesTeamPositionsData?.salesTeamIds.some(
            (x) => x == teamId,
          ) &&
          ownerId != currentUser.userId) ||
        (!currentUser.isAdmin &&
          !isGuestUser &&
          currentUser.salesTeamPositionsData?.salesTeamIds.some(
            (x) => x == teamId,
          ) &&
          salesTeam?.structuredSharing &&
          ownerId != 'unassigned' &&
          ownerId != '' &&
          ownerId != currentUser.userId &&
          !currentUser.salesTeamPositionsData?.salesTeamPositions.some(
            (x) => x == `${teamId}_${ownerId}`,
          ))
      )
    } else {
      return false
    }
  }, [
    positionsDataStatus,
    currentUser,
    teamId,
    isGuestUser,
    ownerId,
    salesTeam?.structuredSharing,
  ])

  const positionBasedAccessText = useMemo(() => {
    if (
      positionsDataStatus == 'success' &&
      currentUser &&
      teamId != '' &&
      teamId > 0
    ) {
      return !currentUser.isAdmin &&
        !isGuestUser &&
        currentUser.salesTeamPositionsData?.salesTeamIds.some(
          (x) => x == teamId,
        ) &&
        salesTeam?.structuredSharing &&
        ownerId != 'unassigned' &&
        ownerId != '' &&
        ownerId != currentUser.userId &&
        !currentUser.salesTeamPositionsData?.salesTeamPositions.some(
          (x) => x == `${teamId}_${ownerId}`,
        )
        ? noAccessUserSave
        : ''
    } else {
      return ''
    }
  }, [
    positionsDataStatus,
    currentUser,
    teamId,
    isGuestUser,
    salesTeam?.structuredSharing,
    ownerId,
  ])

  return {
    positionBasedAccessText,
    selectedSalesTeamAccessText,
    disableSaveAndView,
  }
}
